import React from 'react';
import { useMyVwContext } from './use-my-vw-context';
import { applyTextTransformations } from '../utils/applyTextTransformations';

export interface Disclaimer {
  number: string;
  description: string | React.JSX.Element[];
  token: string;
}

export interface UseDisclaimersReturn {
  disclaimers: Disclaimer[];
  getDisclaimerByNumber: (number: string) => Disclaimer | undefined;
}

export const useDisclaimers = (): UseDisclaimersReturn => {
  const { translationHandler } = useMyVwContext();

  const disclaimers: Disclaimer[] = [
    {
      number: '1',
      description: applyTextTransformations(
        translationHandler('login.disclaimer.text'),
        ['myVW', 'MyVW', 'Volkswagen'],
        [],
      ),
      token: 'MYVW_DISCLAIMER_1',
    },
  ];

  const getDisclaimerByNumber = (number: string): Disclaimer | undefined => {
    return disclaimers.find((disclaimer) => disclaimer.number === number);
  };

  return {
    disclaimers,
    getDisclaimerByNumber,
  };
};
